<template>
    <div class="about">
        <div>
                <b-img :src="require('../../assets/HION_INTRO_2020.jpg')" fluid-grow alt="Hion Tecnologia"></b-img>
        </div>
        <div class="sobreNos">
            <mq-layout :mq="['xs', 'sm']">
                <ArgolasEffect :configArgolas="configArgolas" class="argsup" />
            </mq-layout>
            <b-container class="conteudoHome1">
                <b-row>
                    <b-col cols="12" class="text-center TituloAbout">SOBRE NÓS</b-col>
                    <b-col cols="12" class="text-center TextoAbout">
                    A Hion Soluções e Tecnologia atua para atender as demandas específicas de cada cliente. 
                    É uma empresa focada em Sistemas de Armazenamento de Energia, Veículos Elétricos e Híbridos, 
                    Gestão de Projetos Tecnológicos, Sistemas Embarcados e Sistemas de Gestão da Qualidade - ABNT NBR ISO 9001.
                    A empresa desenvolve soluções técnicas e administrativas para otimizar seu plano estratégico, 
                    seus produtos e seus processos. Atuando de forma customizada para cada projeto adotando 
                    padrões modernos de sustentabilidade e respeitando o perfil e as necessidade de cada cliente
                    </b-col>
                </b-row>
                <b-row class="linkExt">
                    <b-col cols="12" md="4" @click="openCardSomos">
                        <img
                            src="../../assets/somosHome_1_small.jpg"
                            alt="Hion Tecnologia"
                            class="thumbSomos"
                        >
                        <p class="thumbLegenda" id="somosLegenda">QUEM SOMOS</p>
                    </b-col>
                    <b-col cols="12" md="4" @click="openCardValores" class="text-center">
                        <img
                            src="../../assets/valoresHome_1_small.jpg"
                            alt="Hion Tecnologia"
                            class="thumbValores"
                        >
                        <p class="thumbLegenda" id="valoresLegenda">VALORES</p>
                    </b-col>
                    <b-col cols="12" md="4" @click="openCardMissao">
                        <img
                            src="../../assets/missaoHome_1_small.jpg"
                            alt="Hion Tecnologia"
                            class="thumbMissao"
                        >
                        <p class="thumbLegenda" id="missaoLegenda">MISSÃO</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="4">
                        <LinhaHorizontal class="linhaesq" :configLinhas="configLinhas" />
                    </b-col>
                    <b-col cols="12" md="4"></b-col>
                    <b-col cols="12" md="4">
                        <ArgolasEffect :configArgolas="configArgolas" class="argdir" />
                    </b-col>
                </b-row>
            </b-container>
            <LinhaHorizontal class="linhasup" :configLinhas="configLinhas" />
        </div>

        <b-collapse class="collapseAbout" id="collapsesomos" v-model="somosCollapsed">
            <div class="cardSomos">
                <b-container fluid class="containerSomos">
                    <b-row align-v="start" class="cardSomosStart">
                        <b-col cols="3" md="2" align-self="center" class="text-center"
                          v-b-toggle.collapsesomos v-scroll-to="'.linkExt'">
                            <i class="far fa-times-circle CloseBotAbout"></i>
                        </b-col>
                        <b-col cols="6" md="8" align-self="center" class="text-center">
                            <AneisEffect class="efeitoAneisAbout" :configAneis="configAneisAbout" />
                        </b-col>
                        <b-col cols="3" md="2" align-self="center" class="text-right">
                            <HionEffect class="HionEffectAbout" :configHionEffect="configHionEffectAbout" Raio="true" />
                        </b-col>
                    </b-row>
                    <b-row align-v="center" class="cardSomosCenter">
                        <b-col cols="12" md="4" align-self="center" class="text-center colSomosTitle">
                            QUEM <br> <strong> SOMOS </strong>
                        </b-col>
                        <b-col cols="12" md="7" lg="6" align-self="center" class="text-center colSomosTexto">
                            Com ampla experiência no segmento de eletrônica embarcada,
                            por muitos anos realizamos pesquisas e desenvolvimento para sistemas 
                            automotivos com foco em gerenciamento eletrônico de motores a combustão interna,
                            veículo híbridos e elétricos. <br><br>
                            Hoje a HION desenvolve <strong> baterias inteligentes </strong> para
                            ajudar a indústria, o comércio e o agronegício a resolver seus gargalos
                            operacionais com a segurança, agilidade e eficiência da Internet das Coisas.
                        </b-col>
                        <b-col cols="0" md="1" lg="2" align-self="center" class="text-right">
                            <mq-layout mq="lg+">
                                <LinhaHorizontal class="linhaDirAbout" :configLinhas="configLinhas" />
                            </mq-layout>
                        </b-col>
                    </b-row>
                    <b-row align-v="end" class="cardSomosEnd">
                        <b-col cols="3" md="2" align-self="center" class="text-left">
                            <AneisEffect class="efeitoAneisAbout" :configAneis="configAneisAbout" />
                        </b-col>
                        <b-col cols="6" md="8" align-self="center" class="text-center">
                            <LinhaHorizontal class="linhaInfAbout" :configLinhas="configLinhas" />
                        </b-col>
                        <b-col cols="3" md="2" align-self="center" class="text-right">
                            <ArgolasEffect :configArgolas="configArgolas" class="argSupAbout" />
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </b-collapse>

        <b-collapse class="collapseAboutvalores" id="collapsevalores" v-model="valoresCollapsed">
            <div class="cardSomos">
                <b-container fluid class="containerSomos">
                    <b-row align-v="start" class="cardSomosStart">
                        <b-col cols="3" md="2" align-self="center" class="text-center"
                          v-b-toggle.collapsevalores v-scroll-to="'.linkExt'">
                            <i class="far fa-times-circle CloseBotAbout"></i>
                        </b-col>
                        <b-col cols="6" md="8" align-self="center" class="text-center">
                            <AneisEffect class="efeitoAneisAbout" :configAneis="configAneisAbout" />
                        </b-col>
                        <b-col cols="3" md="2" align-self="center" class="text-right">
                            <HionEffect class="HionEffectAbout" :configHionEffect="configHionEffectAbout" Raio="true" />
                        </b-col>
                    </b-row>
                    <b-row align-v="center" class="cardSomosCenter">
                        <b-col cols="12" md="4" align-self="center" class="text-center colSomosTitle">
                            NOSSOS <br> <strong> VALORES </strong>
                        </b-col>
                        <b-col cols="12" md="7" lg="6" align-self="center" class="text-center colSomosTexto">
                            Respeito ao meio ambiente em primeiro lugar, com produtos e serviços de alta qualidade, 
                            atuando no desenvolvimento de novas tecnologias para ajudar a sociedade brasileira e mundial, 
                            sem distinção de classes, a se desenvolver e evoluir pessoalmente e profissionalmente.
                            Criando uma nova cultura corporativa totalmente sustentável através de um ambiente de trabalho 
                            moderno, eficiente e Feliz. Incentivando o colaborativismo integral de conhecimento e serviços, 
                            em uma equipe unida e satisfeita. <br><br>
                            Valorizamos a <strong>quebra de paradigmas tradicionais</strong> e da mentalidade corporativa 
                            do século passado. Queremos contribiur para uma humanidade livre e independente da energia 
                            proveniente dos Combustíveis Fósseis.
                        </b-col>
                        <b-col cols="0" md="1" lg="2" align-self="center" class="text-right">
                            <mq-layout mq="lg+">
                                <LinhaHorizontal class="linhaDirAbout" :configLinhas="configLinhas" />
                            </mq-layout>
                        </b-col>
                    </b-row>
                    <b-row align-v="end" class="cardSomosEnd">
                        <b-col cols="3" md="2" align-self="center" class="text-left">
                            <AneisEffect class="efeitoAneisAbout" :configAneis="configAneisAbout" />
                        </b-col>
                        <b-col cols="6" md="8" align-self="center" class="text-center">
                            <LinhaHorizontal class="linhaInfAbout" :configLinhas="configLinhas" />
                        </b-col>
                        <b-col cols="3" md="2" align-self="center" class="text-right">
                            <ArgolasEffect :configArgolas="configArgolas" class="argSupAbout" />
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </b-collapse>

        <b-collapse class="collapseAboutmissao" id="collapsemissao" v-model="missaoCollapsed">
            <div class="cardSomos">
                <b-container fluid class="containerSomos">
                    <b-row align-v="start" class="cardSomosStart">
                        <b-col cols="3" md="2" align-self="center" class="text-center"
                          v-b-toggle.collapsemissao v-scroll-to="'.linkExt'">
                            <i class="far fa-times-circle CloseBotAbout"></i>
                        </b-col>
                        <b-col cols="6" md="8" align-self="center" class="text-center">
                            <AneisEffect class="efeitoAneisAbout" :configAneis="configAneisAbout" />
                        </b-col>
                        <b-col cols="3" md="2" align-self="center" class="text-right">
                            <HionEffect class="HionEffectAbout" :configHionEffect="configHionEffectAbout" Raio="true" />
                        </b-col>
                    </b-row>
                    <b-row align-v="center" class="cardSomosCenter">
                        <b-col cols="12" md="4" align-self="center" class="text-center colSomosTitle">
                            NOSSA <br> <strong> MISSÃO </strong>
                        </b-col>
                        <b-col cols="12" md="7" lg="6" align-self="center" class="text-center colSomosTexto">
                            Contribuir para <strong>Erradicação</strong> da Energia proveniente dos <strong>Combustíveis Fósseis</strong>.
                            Ser referência global e inspiração nacional em Tecnologia Embarcada, conectividade e
                            <strong>Sistemas Inteligentes de Armazenamento de Energia </strong>.<br><br>Contribuindo para
                            um Brasil socialmente mais forte por meio da Tecnologia de Ponta. Melhorando a vida das
                            pessoas, criando e fornecendo soluções e processos sustentáveis, para o Armazenamento
                            Energético consciente, sem desperdícios, em um mundo cada vez mais Renovável e Limpo.
                        </b-col>
                        <b-col cols="0" md="1" lg="2" align-self="center" class="text-right">
                            <mq-layout mq="lg+">
                                <LinhaHorizontal class="linhaDirAbout" :configLinhas="configLinhas" />
                            </mq-layout>
                        </b-col>
                    </b-row>
                    <b-row align-v="end" class="cardSomosEnd">
                        <b-col cols="3" md="2" align-self="center" class="text-left">
                            <AneisEffect class="efeitoAneisAbout" :configAneis="configAneisAbout" />
                        </b-col>
                        <b-col cols="6" md="8" align-self="center" class="text-center">
                            <LinhaHorizontal class="linhaInfAbout" :configLinhas="configLinhas" />
                        </b-col>
                        <b-col cols="3" md="2" align-self="center" class="text-right">
                            <ArgolasEffect :configArgolas="configArgolas" class="argSupAbout" />
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import HionEffect from '../efeitos/hion_globo'
import LinhaHorizontal from '../efeitos/LinhaHorizontal'
import ArgolasEffect from '../efeitos/Argolas'
import AneisEffect from '../efeitos/Aneis'

export default {
    name: 'About',
    components: { HionEffect, LinhaHorizontal, ArgolasEffect, AneisEffect},
     props: {
        EventoThumblerlHome: {
            type: String,
            default: 'EventoThumblerNaoEmitido'
        }
    },
    data() {
        return {
            configLinhas: {
                backgroundLinhas: "eee",
                CorLinhas: "#008fac"
            },
            configArgolas: {
                backgroundArgolas: "#eee",
                CorArgola: "#008fac"
            },
            configHionEffectAbout: {
                backgroundHionEffect: "#eee",
                CorHionEffect:"#008fac",
                CorRaio:"#ffd618"
            },
            configAneisAbout: {
                backgroundAneis: "#eee",
                CorAneis: "#008fac",
            },
            somosCollapsed: false,
            valoresCollapsed: false,
            missaoCollapsed: false,
        };
    },
    methods: {
        openCardSomos() {
            if(this.valoresCollapsed) this.valoresCollapsed = false
            if(this.missaoCollapsed) this.missaoCollapsed = false
            if(!this.somosCollapsed) this.somosCollapsed = true
            setTimeout(function(){
                VueScrollTo.scrollTo('#collapsesomos')
            }, 500);
        },
        openCardValores() {
            if(this.somosCollapsed) this.somosCollapsed = false
            if(this.missaoCollapsed) this.missaoCollapsed = false
            if(!this.valoresCollapsed) this.valoresCollapsed = true
            setTimeout(function(){
                VueScrollTo.scrollTo('#collapsevalores')
            }, 500);
        },
        openCardMissao() {
            if(this.valoresCollapsed) this.valoresCollapsed = false
            if(this.somosCollapsed) this.somosCollapsed = false
            if(!this.missaoCollapsed) this.missaoCollapsed = true
            setTimeout(function(){
                VueScrollTo.scrollTo('#collapsemissao')
            }, 500);
        },
        checkEventoEmitido(){

            if(this.EventoThumblerlHome == 'QuemSomos') this.openCardSomos()
            if(this.EventoThumblerlHome == 'Valores') this.openCardValores()
            if(this.EventoThumblerlHome == 'Missao') this.openCardMissao()
        }
    },
    mounted() {
        this.checkEventoEmitido();
    }
}
</script>

<style>
.about {
    background: black;
    color:#eee;
    height: 100%;
}
.sobreNos {
    min-height: 500px;
    height: 700px;
    width: 100%;
    background: #eee;
}

.collapseAbout {
    height: 600px;
    width: 100%;
    background: #eee;
    transition: 0.3s;
}
.collapseAboutvalores {
    height: 800px;
    width: 100%;
    background: #eee;
    transition: 0.3s; 
}
.collapseAboutmissao {
    height: 700px;
    width: 100%;
    background: #eee;
    transition: 0.3s;
}

.cardSomos {
    position: relative;
    width: 98%;
    height: 95%;
    border: solid 2px #2e2d2c;
    border-radius: 20px;
    background: #eee;
    margin: auto;
    box-shadow: 0 4px 8px 0 rgba(46, 45, 44, 0.6), 0 6px 20px 0 rgba(46, 45, 44, 0.3);
}
.containerSomos{
    height: 100%;
}
.cardSomosStart {
    height: 20%;
    color: #2e2d2c;
}
.cardSomosCenter {
    height: 60%;
    color: #2e2d2c;
}
.cardSomosEnd {
    height: 20%;
    color: #2e2d2c;
}

.colSomosTitle {
    font-family: 'Play';
    font-size:3.5em;
}
.colSomosTexto {
    font-family: 'Raleway';
    font-size: 1.2em;
    padding: 0px;
}
.linhaDirAbout {
    width: 240px;
    height: 55px;
    transform:rotate(90deg);
}
.linhaInfAbout {
    width: 240px;
    height: 55px;
    transform:rotate(180deg);
}

.argSupAbout {
    width: 30px;
    height: 60px;
    transform:rotate(90deg);
}
.HionEffectAbout{
    height: 100px;
    width: 100px;
}
.efeitoAneisAbout {
    width: 33.33px;
    height: 100px;
    transform: rotate(90deg);
}
.linhaInfAbout {
    left: 200px;
}

.CloseBotAbout {
    color:#008fac;
    font-size:3em;
    cursor: pointer;
}

@media (min-width: 768px) and (max-width:991px) {
.sobreNos {
    height: 800px;
}
}

@media (min-width: 576px) and (max-width:767px) {
.sobreNos {
    height: 1700px;
}
.collapseAbout {
    height: 800px;
}
.collapseAboutvalores {
    height: 1100px;
}
.collapseAboutmissao {
    height: 900px;
}
.colSomosTexto {
    font-size: 1.2em;
    padding: 10px 30px;
}
.linhaInfAbout {
    left: 50px;
}

}

@media (max-width:575px) {

.sobreNos {
    height: 1900px;
}
.collapseAbout {
    height: 1000px;
}
.collapseAboutvalores {
    height: 1300px;
}
.collapseAboutmissao {
    height: 1100px;
}
.colSomosTexto {
    font-size: 1.3em;
    padding: 10px 30px;
}
.linhaInfAbout {
    left: 10px;
}
}

</style>